import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CoreMediaService {
  currentMediaQuery: string;
  onMediaUpdate: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private breakpoints = {
    'bs-xs': '(max-width: 575.98px)',
    'bs-sm': '(min-width: 576px) and (max-width: 767.98px)',
    'bs-md': '(min-width: 768px) and (max-width: 991.98px)',
    'bs-lg': '(min-width: 992px) and (max-width: 1199.98px)',
    'bs-xl': '(min-width: 1200px)',
    'bs-gt-sm': '(min-width: 576px)',
    'bs-gt-md': '(min-width: 768px)',
    'bs-gt-lg': '(min-width: 992px)',
    'bs-gt-xl': '(min-width: 1200px)',
    'bs-lt-sm': '(max-width: 575.98px)',
    'bs-lt-md': '(max-width: 767.98px)',
    'bs-lt-lg': '(max-width: 991.98px)',
    'bs-lt-xl': '(max-width: 1199.98px)'
  };

  constructor(private breakpointObserver: BreakpointObserver) {
    this.currentMediaQuery = '';
    this._init();
  }

  private _init(): void {
    this.breakpointObserver
      .observe(Object.values(this.breakpoints))
      .pipe(
        debounceTime(500),
        map(() => this.getCurrentBreakpoint()),
        distinctUntilChanged()
      )
      .subscribe((alias: string) => {
        if (this.currentMediaQuery !== alias) {
          this.currentMediaQuery = alias;
          this.onMediaUpdate.next(alias);
        }
      });
  }

  private getCurrentBreakpoint(): string {
    for (const [alias, query] of Object.entries(this.breakpoints)) {
      if (this.breakpointObserver.isMatched(query)) {
        return alias;
      }
    }
    return '';
  }

  isActive(breakpoint: string): boolean {
    const query = this.breakpoints[breakpoint];
    return query ? this.breakpointObserver.isMatched(query) : false;
  }
}
